const AssignmentStatus = {
  Assigned: 1,
  NotAccessible: 2,
  PartiallyAssigned: 3,
  NotAssigned : 4
};
    
export default AssignmentStatus;